// extracted by mini-css-extract-plugin
module.exports = {"auth_dropdown_content":"styles_auth_dropdown_content__DsW2q","user_initials_wrapper":"styles_user_initials_wrapper__xt8aU","desktop_dropdown":"styles_desktop_dropdown__wIfCr"};